/* eslint-disable no-console,no-undef,camelcase */
import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { ImageUrl } from "../../utils/constants";
import {
  convertDateInTimezone,
  getTimeToShow,
  convertMonthFromDate,
  getChallengeTimeShowNew,
  getChallengeTimeToShowNew,
} from "../../utils/methods";
import {RecognitionEyeIconNew} from '../../utils/icons'
import isNull from "lodash/isNull";
import { withTranslation } from "react-i18next";
import { joinOrLeaveChallenge } from "../../redux/actions/challengeActions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { ChallengeCard } from "../ChallengeDashboardV2/DashboardCards/styles";
import LazyImage from "../common/LazyImage/LazyImage";
import Waiting from "../Waiting";
import {BottomCard, ImageCard } from './style'

class NewSingleChallenge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: [],
      times: [],
    };
  }

  componentDidMount() {
    const { challenge } = this.props;
    this.setState({
      time: challenge && getChallengeTimeShowNew(challenge, this.props),
    });
    this.interval = setInterval(() => {
      this.setState({
        times: getTimeToShow(challenge, "challenge"),
      });
    }, 1000);
  }

  componentDidUpdate(prevProps) {
    const { challenge } = this.props;
    if (prevProps.challenge.id !== challenge.id) {
      this.setState({
        time: challenge && getChallengeTimeToShowNew(challenge, this.props),
      });
    }
    if (prevProps.challenge !== this.props.challenge) {
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.setState({
          times: getTimeToShow(this.props.challenge, "challenge"),
        });
      }, 1000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  fallBack = (e) => {
    e.target.src = "/images/fallback.png";
  };

  challengeNavigation = (challengeId, isDummy) => {
    const { history, toggleDummyChallenges, adminChallenge, adminDashboard } = this.props;
    if (isDummy) toggleDummyChallenges(true);
    if(adminDashboard){
      history.push(`/company/challenges/${challengeId}`);
    }else if(adminChallenge){
      history.push(`/company/challenges/completed/${challengeId}${isDummy ? "?ACME=true" : ""}`);
    }else{
      history.push(`/challenges/${challengeId}${isDummy ? "?ACME=true" : ""}`);
    }
  };

  joinChallenge = (challengeId, isJoined) => {
    const { joinOrLeaveChallenge } = this.props;
    const data = {
      challenge_id: challengeId,
      is_joined: isJoined,
    };
    joinOrLeaveChallenge(data);
  };

  render() {
    const { challenge,  t , showAll, onHover, onEnterMouse ,onLeaveMouse, } = this.props;
    if (isNull(challenge)) {
      return <Waiting />;
    }
    let challengeId = challenge.id;
    const lang = localStorage.getItem("lang");
    return (
      <ChallengeCard
        onClick={() =>
          this.challengeNavigation(challengeId, challenge.is_dummy_challenge)
        }
        width={showAll ? "399px" : "399px"}
        onMouseEnter={() => onEnterMouse(challengeId)} onMouseLeave={() => onLeaveMouse()}
      >
        <ImageCard height="252px" isBackgroundColor={"#DA6C74"}>
          <LazyImage src={`${ImageUrl}/${challenge.image}`} alt="challenge" />
          { onHover === challengeId &&
            <div className="background">
              <div className="getStarted" onClick={() => this.challengeNavigation(challenge)}>
                <span className="eye">{RecognitionEyeIconNew("#FEFEFE")}</span>
                {t("View Challenge")}
              </div> 
            </div>
          }
        </ImageCard>
        <BottomCard>
          <div className="title">{(challenge.title)}</div>
          <div className="date">
            { (lang !== "fr") ? (convertMonthFromDate(moment(convertDateInTimezone(challenge.start_date)._d).format(
              "DD, MMM YYYY"
            ), this.props)) : (convertMonthFromDate(moment(convertDateInTimezone(challenge.start_date)._d).format(
              "DD, MMM YYYY"
            ), this.props))}
            {" "}-{" "}
            { (lang !== "fr") ? (convertMonthFromDate(moment(convertDateInTimezone(challenge.end_date)._d).format(
              "DD, MMM YYYY"
            ), this.props)) : (convertMonthFromDate(moment(convertDateInTimezone(challenge.end_date)._d).format(
              "DD, MMM YYYY"
            ), this.props))}
          </div>
        </BottomCard>
      </ChallengeCard>
    );
  }
}

NewSingleChallenge.propTypes = {
  onHover: PropTypes.number,
  onEnterMouse: PropTypes.func.isRequired,
  onLeaveMouse: PropTypes.func.isRequired,
  challenge: PropTypes.object,
  history: PropTypes.object,
  toggleDummyChallenges: PropTypes.func,
  t: PropTypes.func,
  margin: PropTypes.number,
  joinOrLeaveChallenge: PropTypes.func,
  adminChallenge: PropTypes.number,
  challengeAttendees: PropTypes.array,
  showAll : PropTypes.bool,
  adminDashboard: PropTypes.bool
};

const mapDispatchToProps = (dispatch) => ({
  joinOrLeaveChallenge: (data) => dispatch(joinOrLeaveChallenge(data)),
});

const mapStateToProps = (state) => ({
  challengeAttendees: state.challenges.challengeAttendees,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(NewSingleChallenge))
);
